<template>
  <div class="beer page">
    <div class="page-header">
      <div v-if="($mq.resize && $mq.above('769px'))" class="container">
        <h1 class="title">{{ this.name }}</h1>
        <el-input placeholder="Search Beer or Brewery" v-model="searchBeer" @keyup.enter.native="onSearch()" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click.native.prevent="onSearch()"></el-button>
        </el-input>
      </div>
      <div v-else class="m-container">
        <el-input placeholder="Search Beer or Brewery" v-model="searchBeer" @keyup.enter.native="onSearch()" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click.native.prevent="onSearch()"></el-button>
        </el-input>
      </div>
    </div>
    <div class="page-upper-body">
      <div v-if="beer" class="container">
        <el-row class="filter" type="flex" justify="center">
          <el-button class="orange-button" @click="onAllClick()">
            <i class="fa fa-bars"></i>
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.all') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onCoreClick()" :class="{ 'orange-button-reverse': core }">
            <i :class="{ 'active' : core }" class="custom-icon icon-core" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.core') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onBreweryClick()">
            <i class="custom-icon icon-brewery" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.brewery') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onStyleClick()">
            <i class="custom-icon icon-style" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.style') : '' }}
          </el-button>
          <el-button class="orange-button" @click="onRegionClick()">
            <i class="custom-icon icon-region" />
            {{ ($mq.resize && $mq.above('769px')) ? $t('button.region') : '' }}
          </el-button>
        </el-row>
        <el-row class="action" type="flex" justify="center">
          <div class="beer-col-img">
            <div class="beer-poster">
              <div v-if="beer.is_promo" class="ribbon-wrapper-red"><div class="ribbon-red">PROMO</div></div>
              <div v-if="beer.is_core" class="ribbon-wrapper-core"><div class="ribbon-core">CORE</div></div>
              <img :src="beer.beer_image ? beer.beer_image.path : '/static/beer-placeholder.jpg'" />
            </div>
          </div>
          <div class="beer-col">
            <div class="beer-body">
              <h1 class="title">{{ beer.description }}</h1>
              <div class="desc-container">
                <span class="text">Brewery: {{ beer.description2 }}</span>
                <span class="text" v-if="beer.country">Region: {{ beer.country }}</span>
                <span class="text" v-if="beer.beer_style">Style: {{ beer.beer_style }}</span>
                <!-- <span class="description"></span> -->
                <span class="pricetag">{{ $t('currency.malaysia') }} {{ beer.user_price }}</span>
                <el-form v-if="beer.stocks" :label-position="labelPosition" ref="form" :model="form" label-width="150px">
                  <el-form-item v-if="beer.stockslist" label="Warehouse">
                    <el-select v-model="selectedBranch" placeholder="Select" @change="onBranchChange">
                      <el-option
                        v-for="(item, index) in beer.stockslist"
                        :key="index"
                        :label="item.branchName"
                        :value="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Order Quantity">
                    <number-input :width="150" @change="onQtyChange(beer)" :quantity.sync="form.quantity" :step="step" :min="min" :max="beer.stocks.qty" />
                    <!-- <el-input-number @change="onQuantityChange(beer)" v-model="form.quantity" size="small" :step="step" :min="min" :max="beer.balsqty"></el-input-number> -->
                  </el-form-item>
                  <span class="text">Available Stock: {{ beer.stocks.qty }}</span>
                </el-form>
                <div class="form-buttons">
                  <el-button class="orange-button button-addtocart" @click="onAddToCartClick()">
                    {{ $t('button.addtocart') }}
                  </el-button>
                  <el-button v-if="alwsample" class="orange-button" @click="onAddSampleClick()">
                    {{ $t('button.addsample') }}
                  </el-button>
                </div>
                <span class="text note">{{ $t('subtitle.orderquantity') }}</span>
              </div>
            </div>
          </div>
        </el-row>
        <!-- <el-row class="stickybutton" v-if="($mq.resize && $mq.below('767px'))" type="flex" justify="center">
          <div class="sticky-col">
            <number-input @change="onQtyChange" :quantity.sync="form.quantity" :step="step" :min="min" :max="beer.balsqty" />
          </div>
          <div class="sticky-col addtocart">
            <el-button class="orange-button" @click="onAddToCartClick()">
              {{ $t('button.addtocart') }}
            </el-button>
          </div>
        </el-row> -->
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div v-if="beer" class="container">
        <el-row>
          <h1 class="title">Beers from Same Brewery</h1>
          <div class="products">
            <div class="item" v-for="(brewery, index) in breweries" :key="index">
              <div class="item-padding">
                <div class="item-container">
                  <div v-if="brewery.is_promo" class="ribbon-wrapper-red"><div class="ribbon-red">PROMO</div></div>
                  <div v-if="brewery.is_core" class="ribbon-wrapper-core"><div class="ribbon-core">CORE</div></div>
                  <a class="poster" :title="brewery.description" @click="onItemClick($t('route.beer'), brewery)">
                    <img :src="brewery.beer_image ? brewery.beer_image.path : '/static/beer-placeholder.jpg'" />
                  </a>
                  <div class="item-brewery">
                    <a :title="brewery.description2" @click="onItemClick($t('route.beer'), product)">
                      <span>{{ brewery.description2 }}</span>
                    </a>
                  </div>
                  <div class="item-desc">
                    <a :title="brewery.description" @click="onItemClick($t('route.beer'), brewery)">
                      <h1>{{ brewery.description }}</h1>
                    </a>
                    <h2>{{ $t('currency.malaysia') }} {{ brewery.user_price ? brewery.user_price : brewery.refprice }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row>
          <h1 class="title">Beers with Same Style</h1>
          <div class="products">
            <div class="item" v-for="(brewery, index) in styles" :key="index">
              <div class="item-padding">
                <div class="item-container">
                  <div v-if="brewery.is_promo" class="ribbon-wrapper-red"><div class="ribbon-red">PROMO</div></div>
                  <div v-if="brewery.is_core" class="ribbon-wrapper-core"><div class="ribbon-core">CORE</div></div>
                  <a class="poster" :title="brewery.description" @click="onItemClick($t('route.beer'), brewery)">
                    <img :src="brewery.beer_image ? brewery.beer_image.path : '/static/beer-placeholder.jpg'" />
                  </a>
                  <div class="item-brewery">
                    <a :title="brewery.description2" @click="onItemClick($t('route.beer'), product)">
                      <span>{{ brewery.description2 }}</span>
                    </a>
                  </div>
                  <div class="item-desc">
                    <a :title="brewery.description" @click="onItemClick($t('route.beer'), brewery)">
                      <h1>{{ brewery.description }}</h1>
                    </a>
                    <h2>{{ $t('currency.malaysia') }} {{ brewery.user_price ? brewery.user_price : brewery.refprice }}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <el-row style="height:50px">
        </el-row>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
      <div class="button-wrapper">
        <div class="buttons" v-for="(item, index) in items" :key="index">
          <el-button round class="dialogbutton" @click="onFilterClick(item)">{{ item.name }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Site from '@/api/site'
import NumberInput from '@/components/NumberInput'
export default {
  name: 'beer',
  components: {
    NumberInput
  },
  props: {
    id: {
      default: undefined
    },
    breweryId: {
      default: undefined
    },
    styleId: {
      default: undefined
    },
    name: {
      type: String,
      default: ''
    }
  },
  localStorage: {
    beers: {
      type: Array,
      default: []
    }
  },
  watch: {
    id () {
      this.onLoad(this.id)
    }
  },
  data () {
    return {
      labelPosition: 'left',
      beer: undefined,
      loading: true,
      isCompleted: false,
      isError: false,
      step: 1,
      min: 0,
      form: {
        quantity: 6
      },
      breweries: [],
      styles: [],
      items: [],
      fcountries: [],
      fbreweries: [],
      fstyles: [],
      dialogTitle: '',
      dialogTableVisible: false,
      searchBeer: '',
      alwsample: false,
      core: 0,
      selectedBranch: 0
    }
  },
  mounted () {
    // console.log(this.$store.getters.groupid)
    this.onLoad(this.id)
    this.getBreweries()
    this.getStyles()
    this.getCountry()
  },
  methods: {
    onLoad (id) {
      if (id) {
        // get beer
        // console.log(this.$store.getters.groupid)
        const data = { id, groupId: this.$store.getters.groupid, branchId: this.$store.getters.branchid }
        // console.log(data)
        Site.getBeer(undefined, data).then((res) => {
          // console.log(res)
          let val = res.result
          if (!val) {
            throw new Error('Something went wrong, result not found.')
          }
          let promoprice
          let userprice
          val.prices.forEach((price) => {
            // console.log(price)
            if (price.uom === 'BOTTLE') {
              if (price.group && price.group.xml_name === 'PROMO') {
                promoprice = price.stockvalue
              } else {
                userprice = price.stockvalue
              }
            } else if (price.uom === 'KEG') {
              if (price.group && price.group.xml_name === 'PROMO') {
                promoprice = price.stockvalue
              } else {
                userprice = price.stockvalue
              }
            }
          })
          this.alwsample = val.alwsample
          val.user_price = promoprice !== undefined ? promoprice : (userprice !== undefined ? userprice : val.refprice)
          if (!val.stocks && val.stockslist && val.stockslist.length > 0) {
            val.stockslist.forEach((item, i) => {
              item.branchName = item.branch.label
            })
            // console.log(val.stockslist)
            this.selectedBranch = 0
            val.stocks = val.stockslist[this.selectedBranch]
          }
          this.beer = val
          // console.log(this.beer)
          // this.min = this.beer.balsqty > this.beer.minqty ? this.beer.minqty : this.beer.balsqty
          this.min = this.beer.stocks.qty > this.beer.minqty ? this.beer.minqty : this.beer.stocks.qty
          // console.log('min', this.min)
          this.form.quantity = this.min

          this.loading = false
          this.isCompleted = true
          // })
          // console.log(this.beer)
          // console.log(res)
        }).catch((err) => {
          this.loading = false
          this.isCompleted = true
          this.isError = true
          console.log(err.response)
        })
        this.getBeer('breweries', { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, breweryId: this.breweryId, limit: 8, exclude: id })
        this.getBeer('styles', { branchId: this.$store.getters.branchid, groupId: this.$store.getters.groupid, styleId: this.styleId, limit: 8, exclude: id })
      } else {
        // redirect to 401
      }
    },
    getBreweries () {
      Site.getBrands().then((res) => {
        this.fbreweries = res.result
      }).catch((err) => {
        console.log(err)
      })
    },
    getStyles () {
      Site.getStyles().then((res) => {
        this.fstyles = res.result
      }).catch((err) => {
        console.log(err)
      })
    },
    getCountry () {
      Site.getCountry().then((res) => {
        this.fcountries = res.result
      }).catch((err) => {
        console.log(err)
      })
    },
    getBeer (name, data) {
      this.loading = true
      Site.getBeer(undefined, data).then((res) => {
        // console.log(res)
        res.result.forEach((val) => {
          let promoprice
          let userprice
          val.prices.forEach((price) => {
            if (price.uom === 'BOTTLE') {
              if (price.group && price.group.xml_name === 'PROMO') {
                promoprice = price.stockvalue
              } else {
                userprice = price.stockvalue
              }
            }
          })
          val.user_price = promoprice !== undefined ? promoprice : (userprice !== undefined ? userprice : val.refprice)
        })
        if (name === 'breweries') {
          this.breweries = res.result
        } else if (name === 'styles') {
          this.styles = res.result
        }
      }).catch((err) => {
        console.log(err.response)
      })
    },
    onAddToCartClick () {
      const data = { beer: {...this.beer}, quantity: this.form.quantity }
      this.$store.dispatch('AddBeer', data).then(() => {
        this.$ls.set('beers', JSON.stringify(this.$store.getters.cartbeers))
        // console.log(this.$store.getters.cartbeers)
      }).catch(err => {
        console.log(err)
      })
    },
    onAddSampleClick () {
      const data = { beer: {...this.beer}, quantity: 1 }
      this.$store.dispatch('AddBeer', data).then(() => {
        this.$ls.set('beers', JSON.stringify(this.$store.getters.cartbeers))
        // console.log(this.$store.getters.cartbeers)
      }).catch(err => {
        console.log(err)
      })
    },
    // onQuantityChange (beer) {
    //   console.log(beer)
    //   return
    //   if (this.form.quantity > this.form.squantity) {
    //     this.count++
    //   } else {
    //     this.count--
    //   }
    //   let quantity = this.count * beer.minqty
    //   if (quantity > beer.balsqty) {
    //     quantity = beer.balsqty
    //   }
    //   this.form.quantity = quantity
    //   this.form.squantity = quantity
    //   // if (this.form.squantity > this.form.quantity) { // - minus
    //   //   this.form.squantity = this.form.quantity
    //   //   if (beer.balsqty - this.sstep === this.form.quantity) {
    //   //     this.sstep = this.min
    //   //     this.step = this.sstep
    //   //   } else {
    //   //     this.form.quantity = this.form.quantity - (this.sstep - this.step)
    //   //   }
    //   // } else if (this.form.squantity < this.form.quantity) {
    //   //   this.form.squantity = this.form.quantity
    //   //   if (beer.balsqty - this.form.quantity < this.min && beer.balsqty - this.form.quantity > 0) {
    //   //     this.sstep = beer.balsqty - this.form.quantity
    //   //     this.step = this.sstep
    //   //   } else {
    //   //     this.step = this.sstep
    //   //   }
    //   // }
    // },
    onQtyChange (val) {
    },
    onBranchChange () {
      // this.selectedBranch = val
      // console.log(this.selectedBranch)
      const stocks = this.beer.stockslist[this.selectedBranch]
      if (stocks) {
        this.beer.stocks = stocks
        this.min = this.beer.stocks.qty > this.beer.minqty ? this.beer.minqty : this.beer.stocks.qty
        this.form.quantity = this.min
      }
    },
    onAllClick () {
      let query = { page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onCoreClick () {
      let core = this.core ? 0 : 1
      let query = { core, page: 1 }
      this.$router.push({ path: `/browse`, query })
    },
    onBreweryClick () {
      this.dialogTitle = this.$t('dialogTitle.brewery')
      this.dialogTableVisible = true
      this.items = this.fbreweries
    },
    onStyleClick () {
      this.dialogTitle = this.$t('dialogTitle.style')
      this.dialogTableVisible = true
      this.items = this.fstyles
    },
    onRegionClick () {
      this.dialogTitle = this.$t('dialogTitle.region')
      this.dialogTableVisible = true
      this.items = this.fcountries
    },
    onSearch () {
      let query = { page: 1, search: this.searchBeer }
      this.$router.push({ path: `/browse`, query })
    },
    onFilterClick (item) {
      let page = 1
      let query
      if (this.dialogTitle === this.$t('dialogTitle.brewery')) {
        query = { page, breweryId: item.id }
      } else if (this.dialogTitle === this.$t('dialogTitle.style')) {
        query = { page, styleId: item.id }
      } else if (this.dialogTitle === this.$t('dialogTitle.region')) {
        query = { page, region: item.id }
      }
      this.$router.push({ path: `/browse`, query })
      this.dialogTitle = ''
      this.dialogTableVisible = false
    },
    onItemClick (name, obj) {
      this.$router.push({ path: `/beer`, query: { id: obj.id, name: obj.description, breweryId: obj.taps_brewery_id } })
    }
  }
}
</script>
<style lang="scss">
.beer {
  .search-form {
    padding-bottom: 0 !important;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  .input-with-select {
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #ECB039;
    }
    .el-input__inner {
      color: #1C1C1C;
      border: 1px solid #ECB039;
    }
    .el-input-group__append {
      background-color: #ECB039;
      color: #1C1C1C;
      border: 1px solid #ECB039;
    }
    .el-input-group__append button.el-button {
      border-color: transparent;
      background-color: #ECB039;
    }
  }
  .el-form {
    // padding-bottom: 25px;
  }
  .el-form-item {
    margin-bottom: 15px;
  }
  .el-form-item__label {
    color: #1C1C1C;
    font-size: 16px;
  }
  .el-input--medium .el-input__inner {
    height: 36px;
    line-height: 36px;
  }
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.el-input--medium .el-input__inner {
  height: 36px !important;
  line-height: 36px !important;
}
.beer {
  .page-header {
    padding: 0;
    @media (min-width: 768px) {
      padding: 0 25px;
    }
    .container {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }
    .m-container {
      display: flex;
      justify-content: center;
      padding: 10px;
      width: 100%;
    }
    .input-with-select {
      max-width: 100%;
      @media (min-width: 768px) {
        max-width: 250px;
      }
    }
  }
  .filter {
    padding: 20px;
  }
  // .search {
  //   padding: 20px;
  //   padding-bottom: 0px;
  // }
  .orange-button {
    // padding: 15px;
    width: auto;
    &.button-addtocart {
      // margin-top: 15px;
    }
  }
  .el-button span {
    display: flex;
    align-items: center;
  }
  .orange-button {
    .custom-icon {
      background-repeat: no-repeat;
      background-size:contain;
      display: inline-block;
      width: 16px;
      height: 16px;
    }
  }
  .orange-button-reverse {
    .custom-icon {
    }
  }
  .icon-core {
    background-image: url(/static/icon-core-black.svg);
  }
  .icon-core.active {
    background-image: url(/static/icon-core-black2.svg);
  }
  .icon-brewery {
    background-image: url(/static/icon-brewery-black.svg);
  }
  .icon-style {
    background-image: url(/static/icon-style-black.svg);
  }
  .icon-region {
    background-image: url(/static/icon-region-black.svg);
  }
  .button-wrapper {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    .buttons {
      width: 50%;
      justify-content: center;
      align-items: center;
      display: flex;
      .dialogbutton {
        width: 90%;
        margin-bottom: 15px;
      }
    }
  }
  .action {
    @media (min-width: 768px) {
      padding: 15px;
    }
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
  }
  .page-body {
    padding: 0 10px;
    @media (min-width: 768px) {
      padding: 0 15px;
    }
  }
  .page-upper-body {
    background-color: $white-color;
  }
  .beer-col-img {
    width: 100%;
    @media (min-width: 768px) {
      width: 40%;
    }

    .beer-poster {
      position: relative;
      & >img {
        display: block;
        width: 100%;
        @media (min-width: 768px) {
          border: 1px solid $gray-color;
          border-radius: 4px;
        }
      }
    }
  }
  .beer-col {
    width: 100%;
    @media (min-width: 768px) {
      width: 60%;
    }
    .beer-body {
      padding: 0 15px;
      margin-bottom: 15px;
      @media (min-width: 768px) {
        padding-left: 25px;
        margin-bottom: 0px;
      }
      .desc-container {
        padding: 0;
        @media (min-width: 768px) {
          padding-bottom: 15px;
        }
        .deliveryoptions {
          text-decoration: underline;
          color: $orange-light-color;
        }
        .form-buttons {
          padding-top: 5px;
          padding-bottom: 5px;
        }
        & > .title {
          font-size: 18px;
          @media (min-width: 768px) {
            font-size: 22px;
          }
        }
        & > .text {
          padding-bottom: 5px;
          // &.note {
          //   padding-top: 5px;
          // }
        }
        & .description {
          padding-top: 20px;
          padding-bottom: 25px;
        }
        & > .pricetag {
          font-family: 'AlteHaasGroteskBold';
          color: $black-color;
          font-weight: bold;
          font-size: 20px;
          padding-top: 5px;
          padding-bottom: 5px;
          @media (min-width: 768px) {
            padding-top: 15px;
            padding-bottom: 15px;
          }
        }
        & > span {
          display: block;
        }
      }
      .orange-button {
        letter-spacing: normal;
      }
    }
  }
  .stickybutton {
    z-index: 99;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: 100%;
    .sticky-col {
      width: 50%;
      &.addtocart {
        color: $black-color;
        background-color: $orange-light-color;
        & > .orange-button {
          background: transparent;
          max-width: 100%;
          width: 100%;
          letter-spacing: 0;
        }
      }
    }
  }
  .products {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    // column-count: 1;
    @media (min-width: 768px) {
      // column-count: 3;
    }
    .item {
      width: 50%;
      text-align: center;

      @media (min-width: 768px) {
        width: 25%;
      }

      .item-padding {
        padding: 5px;
        @media (min-width: 768px) {
          padding: 10px;
        }
        .item-container {
          position: relative;
          background: #fff;
          border: 1px solid #ccc;
          .poster {
            & img {
              vertical-align: top;
            }
          }
          .item-brewery {
            background-color: $black-color;
            color: $white-color;
            font-weight: bold;
            padding: 3px 0;
            font-size: 12px;
          }
          a {
            cursor: pointer;
            & > h1 {
              width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              margin: 10px 0;
              @media (max-width: 767px) {
                font-size: 16px;
                margin: 5px 0;
              }
            }
          }
          & > .item-desc {
            padding: 0 15px;
            & > h2 {
              margin: 10px 0;
            }
          }
        }
      }
      h1 {
        font-size: 16px;
      }
      h2 {
        font-size: 14px;
        font-weight: normal;
        @media (max-width: 767px) {
          font-size: 12px;
          margin: 5px 0 10px 0;
        }
      }
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/beer/index.vue